import { gql } from '@apollo/client';

import { FullBidFields } from 'query/SellerDealsWithCarves';

import { CarveDiffTableFragments } from '../CarveDiffTable';

const BidCardFragments = {
  TimelineCard: gql`
    fragment BidCard on TimelineCard {
      __typename
      ... on BidCard {
        carve_criteria_section
        upb_criteria_section
        can_edit_counteroffer
        counteroffer_details_section
        asset_class
        role
        bids {
          ...FullBidFields
        }
      }
    }
    ${CarveDiffTableFragments.PerformanceSummary}
    ${FullBidFields}
  `,
};

export default BidCardFragments;
